import type { components } from '@/api/types'

/**
 * Admin moderation action audit-row (DEC-ADMIN-005).
 */
export type AdminModerationAction = NonNullable<components['schemas']['AdminModerationAction']>

export type ModerationActionType =
  | 'approve_photo'
  | 'reject_photo'
  | 'disable_user'
  | 'reinstate_user'
  | 'dismiss_report'
  | 'resolve_report'
  | 'delete_message'

export const MODERATION_ACTION_VALUES: ModerationActionType[] = [
  'approve_photo',
  'reject_photo',
  'disable_user',
  'reinstate_user',
  'dismiss_report',
  'resolve_report',
  'delete_message',
]
